export class VerifyRejectRequest {
    reqId: string;
    notes: string;
    salesforceId: string;
    salesForceSalesOppId: string;

    constructor(appId: string, notes: string, salesforceId: string = "", salesForceSalesOppId: string = "") {
        this.reqId = appId;
        this.notes = notes;
        this.salesforceId = salesforceId;
        this.salesForceSalesOppId = salesForceSalesOppId;
    }
}